import { render, staticRenderFns } from "./businessDatabusList.vue?vue&type=template&id=64b75849&scoped=true"
import script from "./businessDatabusList.vue?vue&type=script&lang=js"
export * from "./businessDatabusList.vue?vue&type=script&lang=js"
import style0 from "./businessDatabusList.vue?vue&type=style&index=0&id=64b75849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b75849",
  null
  
)

export default component.exports